/* Marked measured-form UI guard. This is not a checkout-security control. */
(() => {
  'use strict';
  document.addEventListener('submit', event => {
    if (!event.target.closest('[data-sutton-measured-preview]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const status = event.target.querySelector('[data-sb-product-status]');
    if (status) status.textContent = 'Use the measured calculator above to add your supplied cut to the basket.';
  }, true);
})();
